export const required = (value) => (value ? "" : "Ce champ est obligatoire.");
export const multiSelect = (value) =>
  (value || []).length !== 0 ? "" : "Ce champ est obligatoire.";
export const email = (value = "") =>
  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "L'email n'est pas valide"
    : undefined;
export const compare = (value, value1) => {
  return () =>
    value !== value1 ? "Les mots de passe ne correspondent pas." : "";
};

export const numberRange = (min, max, message) => (value) => {
  // Treat empty value as valid here; required validator should handle emptiness
  if (value === "" || value === null || value === undefined) return "";
  const num = Number(value);
  if (Number.isNaN(num)) return message || "Doit être un nombre.";
  if (typeof min === "number" && num < min)
    return message || `La valeur doit être supérieure ou égale à ${min}.`;
  if (typeof max === "number" && num > max)
    return message || `La valeur doit être inférieure ou égale à ${max}.`;
  return "";
};
